/* Keep overflow navigation as a list, with links beside (never inside) its button. */
function dropdown() {
    const head = document.querySelector('.gh-navigation');
    const menu = head?.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const items = Array.from(nav.children);
    const overflow = document.createElement('li');
    overflow.className = 'gh-overflow-item';
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'gh-more-toggle gh-icon-button';
    toggle.textContent = menu.dataset.moreLabel || 'More';
    toggle.setAttribute('aria-controls', 'navigation-overflow');
    const submenu = document.createElement('ul');
    submenu.id = 'navigation-overflow';
    submenu.className = 'studio-games-dropdown';
    overflow.append(toggle, submenu);

    function setOpen(open) {
        toggle.setAttribute('aria-expanded', String(open));
        submenu.hidden = !open;
    }
    setOpen(false);
    toggle.addEventListener('click', function () {
        setOpen(submenu.hidden);
    });
    document.addEventListener('click', function (event) {
        if (!overflow.contains(event.target) || event.target.closest('a')) setOpen(false);
    });
    overflow.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !submenu.hidden) {
            event.preventDefault();
            event.stopPropagation();
            setOpen(false);
            toggle.focus();
        } else if (event.key === 'ArrowDown' && event.target === toggle) {
            event.preventDefault();
            setOpen(true);
            submenu.querySelector('a, summary')?.focus();
        }
    });
    overflow.addEventListener('focusout', function (event) {
        if (!overflow.contains(event.relatedTarget)) setOpen(false);
    });

    function layout() {
        const focused = document.activeElement;
        // Move existing nodes, preserving Games disclosure and its event handlers.
        items.forEach(item => nav.appendChild(item));
        overflow.remove();
        setOpen(false);
        if (!mediaQuery.matches && nav.scrollWidth > menu.clientWidth) {
            nav.appendChild(overflow);
            let count = items.length;
            while (count && nav.scrollWidth > menu.clientWidth) {
                submenu.prepend(items[--count]);
            }
            if (!submenu.children.length) overflow.remove();
        }
        head.classList.add('is-dropdown-loaded');
        if (focused && items.some(item => item.contains(focused))) {
            if (submenu.contains(focused)) setOpen(true);
            focused.focus({preventScroll: true});
        }
    }
    let frame;
    window.addEventListener('resize', function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(layout);
    });
    layout();
    document.fonts?.ready.then(layout);
    window.addEventListener('load', layout, {once: true});
}
